import { create } from 'zustand';
import type { TAttributeData, ISetting } from '@newo/api/gateway';

interface ISettingsState {
    attributesValues: Partial<Record<string, TAttributeData>>;
    attributesErrors: Record<string, string>;
    chatValues: Record<string, ISetting[] | undefined>;
    chatErrors: Record<string, boolean>;
    voiceValues: Record<string, ISetting[] | undefined>;
    voiceErrors: Record<string, boolean>;
    setAttributesValues: (
        values: Partial<Record<string, TAttributeData>>
    ) => void;
    setAttributesErrors: (errors: Partial<Record<string, string>>) => void;
    setChatValues: (values: Partial<Record<string, ISetting[]>>) => void;
    setChatErrors: (errors: Partial<Record<string, boolean>>) => void;
    setVoiceValues: (values: Partial<Record<string, ISetting[]>>) => void;
    setVoiceErrors: (errors: Partial<Record<string, boolean>>) => void;
    reset: () => void;
}

const initialState = {
    attributesValues: {} as Partial<Record<string, TAttributeData>>,
    attributesErrors: {} as Record<string, string>,
    chatValues: {} as Record<string, ISetting[] | undefined>,
    chatErrors: {} as Record<string, boolean>,
    voiceValues: {} as Record<string, ISetting[] | undefined>,
    voiceErrors: {} as Record<string, boolean>
};

const useSettingsStore = create<ISettingsState>()((set) => ({
    ...initialState,
    setAttributesValues: (values) => {
        set((state) => ({
            attributesValues: {
                ...state.attributesValues,
                ...values
            }
        }));
    },
    setAttributesErrors: (errors) => {
        set((state) => ({
            attributesErrors: {
                ...state.attributesErrors,
                ...errors
            } as Record<string, string>
        }));
    },
    setChatValues: (values) => {
        set((state) => ({
            chatValues: {
                ...state.chatValues,
                ...values
            }
        }));
    },
    setChatErrors: (errors) => {
        set((state) => ({
            chatErrors: {
                ...state.chatErrors,
                ...errors
            } as Record<string, boolean>
        }));
    },
    setVoiceValues: (values) => {
        set((state) => ({
            voiceValues: {
                ...state.voiceValues,
                ...values
            }
        }));
    },
    setVoiceErrors: (errors) => {
        set((state) => ({
            voiceErrors: {
                ...state.voiceErrors,
                ...errors
            } as Record<string, boolean>
        }));
    },
    reset: () => {
        set(initialState);
    }
}));

export default useSettingsStore;
